// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1-AVS","productName":"Table_productName__3pcRk"};